var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconInfoBrain = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeWidth: "2.167", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(0.02 -0.001)" },
                React.createElement("path", { d: "M22.6,21.2c2.9-0.6,4.8-3.5,4.2-6.4c-0.5-2.5-2.7-4.3-5.3-4.3h-1.4c-1.2-4.6-5.9-7.4-10.6-6.2\n\t\ts-7.4,5.9-6.2,10.6c0.6,2.3,2.1,4.3,4.2,5.4" }),
                React.createElement("path", { d: "M14,26v-6.8" }),
                React.createElement("path", { d: "M14,14.8L14,14.8" })))));
});
export default IconInfoBrain;
//# sourceMappingURL=IconInfoBrain.js.map